import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { apiSendRequestSupportEmail } from "../../services/EmailService";
import { apiGetAllProducts } from "../../services/ProductsService";
import { apiGetAllSampleCards } from "../../services/SampleCardsService";
import Button from "../common/Button";
import { DatePicker } from "../common/DatePicker";
import { SelectBox } from "../common/SelectBox";
import { TextArea } from "../common/TextArea";
import { TextBox } from "../common/TextBox";
import { TextBoxEmail } from "../common/TextBoxEmail";
import { useSelector } from "react-redux";
import CheckBox from "../common/CheckBox";
import './Support.css';

interface Props {
    onRequestSent?: any;
}

const translationPrefix = 'Support';

const RequestForColor = (props: Props) => {
    const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });

    const userInfo = useSelector((state: any) => state.userInfo);
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [loadingSampleCards, setLoadingSampleCards] = useState(true);
    const [formData, setFormData] = useState({
        product: null,
        sampleCard: null,
        customSampleCard: null,
        useCustomSampleCard: false,
        color: '',
        email: userInfo.Email,
        name: userInfo.FullName,
        phone: userInfo.Phone,
        dueDate: undefined,
        comment: ''
    });
    const [products, setProducts] = useState([]);
    const [sampleCards, setSampleCards] = useState([]);
    const [productError, setProductError] = useState(false);

    useEffect(() => {
        if (!userInfo) return;

        setFormData(prev => ({
            ...prev,
            email: prev.email || userInfo.Email || '',
            name: prev.name || userInfo.FullName || '',
            phone: prev.phone || userInfo.Phone || ''
        }));
    }, [userInfo]);

    useEffect(() => {
        apiGetAllProducts(false).then(
            (responseData) => {
                if (responseData && responseData.data) {
                    let arr = responseData.data.map((element) => {
                        element.value = element.id;
                        element.label = element.name;
                        return element;
                    });
                    setProducts(arr);
                }
            }
        ).finally(() => {
            setLoadingProducts(false);
        });
        apiGetAllSampleCards().then(
            (responseData) => {
                if (responseData && responseData.data) {
                    let arr = responseData.data.map((element) => {
                        element.value = element.id;
                        element.label = element.name;
                        return element;
                    });
                    setSampleCards(arr);
                }
            }
        ).finally(() => {
            setLoadingSampleCards(false);
        });
    }, []);

    const handleSendRequest = () => {

        let requestFormData = { ...formData };
        
        const extProduct = products.find((p: any) => { return p.value === requestFormData.product }) as any;
        const extSampleCard = sampleCards.find((p: any) => { return p.value === requestFormData.sampleCard }) as any;
        if (extProduct) {
            requestFormData.product = extProduct.label;
        }
        else {
            setProductError(true);
            return;
        }
        if (extSampleCard) {
            requestFormData.sampleCard = extSampleCard.label;
        }

        if (requestFormData.useCustomSampleCard) {
            requestFormData.sampleCard = requestFormData.customSampleCard;
        }


        apiSendRequestSupportEmail(requestFormData).then((response) => {
            props.onRequestSent(true);
            setFormData({
                product: null,
                sampleCard: null,
                useCustomSampleCard: false,
                customSampleCard: null,
                color: '',
                email: '',
                name: '',
                phone: '',
                dueDate: undefined,
                comment: ''
            });
        }).catch((err: any) => {
            props.onRequestSent(false, err);
        });
    }

    return (
        <>
            <SelectBox
                placeholder={t('ProductPlaceHolder')}
                isDisabled={false}
                options={products}
                label={t('Product')}
                formData={formData}
                setStateMethod={setFormData}
                dataField={'product'}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
                value={formData.product}
                isRequired={true}
                className={`${productError ? 'productRedLabelError' : ''}`}
            />

            {!formData.useCustomSampleCard &&
                <SelectBox
                    placeholder={t('SampleBookPlaceHolder')}
                    isDisabled={false}
                    options={sampleCards}
                    label={t('SampleBook')}
                    formData={formData}
                    setStateMethod={setFormData}
                    dataField={'sampleCard'}
                    customLeftCols={'col-sm-2'}
                    customRightCols={'col-sm-4'}
                    value={formData.sampleCard}
                />}
            <div className="row">
                <div className="col-2">
                    <CheckBox
                        id="customSampleCardName"
                        label={t('UseCustomSampleBook')}
                        paddingLeft={"10px"}
                        handleCheckedChange={(checked) => {

                            let newFormData = { ...formData };
                            newFormData.useCustomSampleCard = checked;
                            if (!checked) {
                                newFormData.customSampleCard = null;
                            }
                            setFormData(newFormData);

                        }}
                        defaultValue={formData.useCustomSampleCard}
                    />
                </div>
                <div className="col-10" style={{ paddingLeft: 0 }}>
                    {formData.useCustomSampleCard &&
                        <TextBox
                            id="customSampleCard"
                            label={''}
                            placeholder={''}
                            dataField="customSampleCard"
                            value={formData.customSampleCard}
                            formData={formData}
                            setStateMethod={setFormData}
                            customLeftCols={'col-sm-2'}
                            customRightCols={'col-sm-4'}
                        />}
                </div>
            </div>
            <TextBox
                id="requiredColor"
                label={t('RequiredColor')}
                placeholder={t('RequiredColorPlaceHolder')}
                dataField="color"
                value={formData.color}
                formData={formData}
                setStateMethod={setFormData}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
            />
            <TextBoxEmail
                id="email"
                label={t('Email')}
                placeholder={t('EmailPlaceHolder')}
                dataField="email"
                value={formData.email}
                formData={formData}
                setStateMethod={setFormData}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
            />
            <TextBox
                id="name"
                label={t('Name')}
                placeholder={t('NamePlaceHolder')}
                dataField="name"
                value={formData.name}
                formData={formData}
                setStateMethod={setFormData}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
            />
            <TextBox
                id="phone"
                label={t('Phone')}
                placeholder={t('PhonePlaceHolder')}
                dataField="phone"
                value={formData.phone}
                formData={formData}
                setStateMethod={setFormData}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
            />
            <DatePicker
                id="dueDate"
                label={t('RequiredDate')}
                placeholder={t('RequiredDatePlaceHolder')}
                dataField="dueDate"
                value={formData.dueDate}
                formData={formData}
                setStateMethod={setFormData}
                customLeftCols={'col-sm-2'}
                customRightCols={'col-sm-4'}
            />
            <TextArea
                id={'comment'}
                label={t('Note')}
                placeholder={t('NotePlaceHolder')}
                rows={4}
                dataField="comment"
                formData={formData}
                setStateMethod={setFormData}
                value={formData.comment}
                customColClassForLabel={'col-sm-2'}
                customColClassForValue={'col-sm-4'}
            />
            <Button
                text={t('Submit')}
                onClick={handleSendRequest}
                iconClass={'unset'}
            />
        </>
    );
}

export default RequestForColor;